import './Header.scss';
import React, { useEffect, useState } from 'react';
import { Stack, Typography, Menu, MenuItem, IconButton, useMediaQuery, Divider, CircularProgress } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { logout, signOut } from '../../redux/features/authSlice';
import appapi from '../../api/apiClient';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { setLoading, setIndex } from '../../redux/features/appSlice';
import { colors } from '../../utils/colors';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from '@emotion/react';
import PriceInfo from './PriceInfo';
import defautImg from '../../assets/images/profileDefault.svg';
import ChangePassword from './ChangePassword';
import LanguageSwitcher from '../LanguageSwitcher';
import { useTranslation } from 'react-i18next';
import { CancelToken } from 'apisauce';
import Notification from '../../pages/Layouts/Notification/Notification';
import { initNotifyCount } from '../../redux/features/layoutSlice';

const getTitle = (path) => {
  if (path === '/') {
    return 'DASHBOARD';
  }
  if (path === '/tradeManagement') {
    return 'Trade Management';
  }
  if (path === '/userManagement') {
    return 'User Management';
  }
  if (path === '/fleetManagement') {
    return 'Fleet Management';
  }
  if (path === '/contactManagement') {
    return 'Contact Management';
  }
  if (path === '/clientManagement') {
    return 'Client Management';
  }
  if (path === '/settings') {
    return 'Settings';
  }
  if(path === '/portfolioManagement') {
    return 'Portfolio Management'
  }
  return '';
};

export default function Header() {
  const dispatch = useDispatch();
  const { graphData, notifyCount, transactionData } = useSelector((state) => state.layout);
  const { userId, user, companyDetails } = useSelector((state) => state.auth);
  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [title, setTitle] = useState('');

  const theme = useTheme();
  const { t } = useTranslation();

  let source = CancelToken.source();

  const navigate = useNavigate();

  const Location = useLocation();
  useEffect(() => {
    setTitle(getTitle(Location.pathname));
  }, [Location]);

  //profile menu
  const [anchorEl, setAnchorEl] = useState(false);
  const [anchorE2, setAnchorE2] = useState(false);
  const open = Boolean(anchorEl);
  const openNotify = Boolean(anchorE2);

  // const [notifyCount, setNotifyCount] = useState(0);

  const [payload, setPayload] = useState({
    page: 1,
    limit: 10,
  });

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleNotifyMenuOpen = (event) => {
    setAnchorE2(event.currentTarget);
    dispatch(initNotifyCount())
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleNotifyMenuClose = () => {
    setAnchorE2(null);
  };

  //check whether mobile or not
  const isMobile = useMediaQuery('(max-width:1000px)');

  /**
   * @function Logout user
   */
  const handleLogout = async () => {
    dispatch(setLoading(true));
    handleMenuClose();

    const refresh_token = localStorage.getItem('refreshToken');
    let payload = {
      userId,
      refresh_token,
    };
    const response = await appapi.post(`/auth/logout`, {}, { params: payload });
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;

      if (data.status === '7400') {
        dispatch(signOut());
      } else {
        dispatch(signOut());
      }
    } else {
      dispatch(signOut());
      dispatch(setLoading(false));
      // showmessage(`Something Went Wrong!`, 2000, 'error')
    }
  };

  const onOpenProfile = () => {
    navigate(`/settings/userProfile`);
    dispatch(setIndex(0));
    setAnchorEl(null);
  };

  // useEffect(() => {
  //   getNotifyCount();
  //   return () => {
  //     if (source) {
  //       source.cancel();
  //     }
  //   };
  // }, []);

  // const getNotifyCount = async () => {
  //   setLoading(true);
  //   source.cancel();
  //   source = CancelToken.source();
  //   const response = await appapi.get(
  //     `notification/getNotificationUnReadCount/${user?.companyId}`,
  //     {},
  //     {
  //       cancelToken: source.token,
  //     },
  //   );
  //   if (response.ok) {
  //     const data = response.data;
  //     if (data.status === '7400') {
  //       setNotifyCount(data?.response);
  //     }
  //     setLoading(false);
  //   }
  // };


  return (
    <Stack
      className="headerContainer"
      direction="row"
      style={{
        marginLeft: isMobile ? '56px' : '',
        height: '56px',
        backgroundColor: '#FFFFFF',
      }}
    >
      <Stack justifyContent={'center'}>
        {Boolean(companyDetails?.companyLogo) && (
          <img
            src={companyDetails?.companyLogo}
            alt="logo"
            style={{ height: '50px', width: '50px', marginLeft: '8px' }}
          />
        )}
      </Stack>
      <Stack
        sx={{ height: '100%', width: '100%' }}
        direction="row"
        background={theme.palette.background.main}
        justifyContent="space-between"
        alignItems="center"
      >
        <Stack
          direction="row"
          className="flex"
        >
          <Stack className="border-r-2 border-[rgba(20, 40, 90, 0.16)] justify-center items-center h-[26px]">
            <Typography
              className="fs-16 pr-[10px] ff-Roboto fw-bold"
              style={{
                color: theme.palette.primary.text,
                marginLeft: '11.24px',
                display: 'flex',
                flexDirection: 'column',
                lineHeight: '10px',
              }}
            >
              {companyDetails?.companyName}
            </Typography>
          </Stack>
          <Stack className="justify-center items-center h-[26px]">
            <Typography
              className="fs-16 !uppercase pr-[10px] ff-Roboto fw-medium"
              style={{
                color: theme.palette.primary.text,
                marginLeft: '11.24px',
                marginRight: '11.24px',
                display: 'flex',
                flexDirection: 'column',
                lineHeight: '10px',
              }}
            >
              {t(`${title}`)}
            </Typography>
          </Stack>
        </Stack>

        {
          //120px
        }
        <div
          className="profileSection"
          style={{ minWidth: '40px', backgroundColor: '#FFFF' }}
        >
          <Stack
            sx={{ height: '100%' }}
            direction="row"
            alignItems="center"
          >
            <div
              className="profiledetail flex-aligncenter"
              style={{ flex: '1', width: 'calc(100% - 56px)' }}
            >
              <LanguageSwitcher />
              <Stack sx={{ width: '34px' }} />
              <Stack>
                <PriceInfo graphData={graphData} transactionData={transactionData}/>
              </Stack>
              <Stack
                direction="row"
                flex="1"
                justifyContent="space-between"
                style={{ width: '100%' }}
              >
                <IconButton
                  onClick={handleNotifyMenuOpen}
                  aria-controls={openNotify ? 'resource-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={openNotify ? 'true' : undefined}
                  style={{ marginRight: '10px' }}
                >
                  <NotificationsIcon style={{ width: '20px', color: theme.palette.grey.main }} />
                  {notifyCount &&  notifyCount > 0 ? 
                   <Stack
                   className="w-[15px] h-[15px] rounded-[8px] ml-[15px] mb-[10px] absolute"
                   style={{ backgroundColor: '#CB0000' }}
                   alignItems={'center'}
                   justifyContent={'center'}
                 >
                   <Typography
                     className="ff-Roboto fs-medium"
                     style={{ color: '#FFFFFF', fontSize: '8px' }}
                   >
                     {notifyCount}
                   </Typography>
                 </Stack> : null}
                 
                </IconButton>

                <Menu
                  // className="appbar"
                  id="resource-menu"
                  anchorEl={anchorE2}
                  open={openNotify}
                  MenuListProps={{
                    'aria-labelledby': 'resource-button',
                  }}
                  onClose={handleNotifyMenuClose}
                  PopperProps={{
                    placement: 'bottom-end',
                  }}
                  PaperProps={{
                    style: {
                      width: '360px',
                      // height: '300px',
                    },
                  }}
                >
                  <Notification
                    handleNotifyMenuClose={() => handleNotifyMenuClose()}
                    // getNotifyCount={() => getNotifyCount()}
                  />
                </Menu>
              </Stack>

              <Stack
                direction="row"
                flex="1"
                justifyContent="space-between"
                style={{ width: '100%' }}
              >
                <IconButton
                  id="resource-button"
                  onClick={handleMenuOpen}
                  aria-controls={open ? 'resource-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? 'true' : undefined}
                  style={{ marginRight: '10px' }}
                >
                  <img
                    src={user?.profileImage ? user?.profileImage : defautImg}
                    alt="ProfileImage"
                    style={{ objectFit: 'cover' }}
                  />
                </IconButton>

                <Menu
                  className="appbar"
                  id="resource-menu"
                  anchorEl={anchorEl}
                  open={open}
                  MenuListProps={{
                    'aria-labelledby': 'resource-button',
                  }}
                  onClose={handleMenuClose}
                  PopperProps={{
                    placement: 'bottom-end',
                  }}
                  PaperProps={{
                    style: {
                      width: '217px',
                      marginTop: '5px',
                    },
                  }}
                >
                  <MenuItem
                    className="ff-Roboto fs-12 fs-medium"
                    style={{ color: colors.blackMain, minHeight: '32px' }}
                    onClose={handleMenuClose}
                    onClick={() => setOpenChangePassword(true)}
                  >
                    {t('Change Password')}
                  </MenuItem>
                  <MenuItem
                    className="ff-Roboto fs-12 fs-medium"
                    style={{ color: colors.blackMain, minHeight: '32px' }}
                    onClose={handleMenuClose}
                    onClick={() => handleLogout()}
                  >
                    {t('Logout')}
                  </MenuItem>
                </Menu>
              </Stack>
            </div>
          </Stack>
        </div>
      </Stack>
      {openChangePassword && (
        <ChangePassword
          modelOpen={openChangePassword}
          onModelHandleClose={() => setOpenChangePassword(false)}
        />
      )}
    </Stack>
  );
}
